import React from 'react'
import useContributionChangeLogFlag from '../data-service/useContributionChangeLogFlag'
import ChangeLogChangesPageSkeleton from './components/ChangeLogPage/ChangeLogChangesPageSkeleton'
import ContributionsPageSkeleton from './components/ContributionsComponents/ContributionsPageSkeleton'

export default function ChangeLogPageSkeleton(): JSX.Element {
  const showNewChangelog = useContributionChangeLogFlag().data?.isOn

  if (showNewChangelog) {
    return <ContributionsPageSkeleton />
  }
  return <ChangeLogChangesPageSkeleton />
}
